import React, { useState } from 'react';

/* ──────── DATA ──────── */
const REMOVED = [
  { ref:'Matthew 12:47', v:'NIV: F · RSV: T · NRSV: F' },
  { ref:'Matthew 17:21', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: F' },
  { ref:'Matthew 18:11', v:'NIV: T · NASV: F · RSV: T · NRSV: T · NCV: T' },
  { ref:'Matthew 21:44', v:'NIV: F · RSV: T · NRSV: F · NCV: F' },
  { ref:'Matthew 23:14', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T' },
  { ref:'Mark 7:16', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Mark 9:44', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Mark 9:46', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Mark 11:26', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Mark 15:28', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: F' },
  { ref:'Mark 16:9-20', v:'NIV: F · NASV: F · NKJV: F · RSV: F · NRSV: F · NCV: F · LIV: F' },
  { ref:'Luke 17:36', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T' },
  { ref:'Luke 22:43', v:'NIV: F · NASV: F · RSV: T · NRSV: F' },
  { ref:'Luke 22:44', v:'NIV: F · NASV: F · RSV: T · NRSV: F' },
  { ref:'Luke 23:17', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Luke 24:12', v:'NASV: F · RSV: T · NRSV: F' },
  { ref:'Luke 24:40', v:'NASV: T · RSV: T · NRSV: F' },
  { ref:'John 5:4', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: F' },
  { ref:'John 7:53-8:11', v:'NIV: F · NASV: F · RSV: T · NRSV: F · NCV: F · LIV: F' },
  { ref:'Acts 8:37', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: F' },
  { ref:'Acts 15:34', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Acts 24:7', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T' },
  { ref:'Acts 28:29', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
  { ref:'Romans 16:24', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T' },
  { ref:'1 John 5:7', v:'NIV: T · NASV: T · RSV: T · NRSV: T · NCV: T · LIV: T' },
];

const DEITY = [
  {
    title: '"God Manifest in the Flesh"',
    kjvRef: '1 Timothy 3:16',
    kjv: '"And without controversy great is the mystery of godliness: GOD was manifest in the flesh..."',
    issue: 'Changed "God" to "He" or "He who." This removes the direct statement that it was God manifest in the flesh.',
    examples: [
      { ver:'NIV', text:'"Beyond all question, the mystery from which true godliness springs is great: HE appeared in the flesh..."' },
      { ver:'ESV', text:'"Great indeed, we confess, is the mystery of godliness: HE was manifested in the flesh..."' },
    ],
  },
  {
    title: '"The Son of God" Removed',
    kjvRef: 'Mark 1:1',
    kjv: '"The beginning of the gospel of Jesus Christ, THE SON OF GOD;"',
    issue: 'OMIT "the Son of God." This removes the declaration of Christ\'s divine sonship from the very first verse of Mark.',
    examples: [
      { ver:'RSV', text:'"The beginning of the gospel of Jesus Christ." [THE SON OF GOD OMITTED]' },
      { ver:'NIV (footnote)', text:'"The beginning of the good news about Jesus the Messiah, the Son of God" with footnote casting doubt' },
    ],
  },
  {
    title: '"Christ, the Son of the Living God"',
    kjvRef: 'John 6:69',
    kjv: '"...thou art that CHRIST, THE SON OF THE LIVING GOD."',
    issue: 'Changed to "the Holy One of God." This removes Peter\'s confession that Jesus is the Christ and the Son of the living God.',
    examples: [
      { ver:'NIV', text:'"...you are THE HOLY ONE OF GOD."' },
      { ver:'ESV', text:'"...you are THE HOLY ONE OF GOD."' },
    ],
  },
  {
    title: '"Begotten" Removed',
    kjvRef: 'John 3:16',
    kjv: '"For God so loved the world, that he gave his only BEGOTTEN Son..."',
    issue: 'Removed the word "begotten." This reduces the unique relationship between the Father and Son, blurring the distinction between Christ\'s eternal sonship and our adopted sonship.',
    examples: [
      { ver:'NIV', text:'"For God so loved the world that he gave his ONE AND ONLY Son..."' },
      { ver:'ESV', text:'"For God so loved the world, that he gave his ONLY Son..."' },
    ],
  },
  {
    title: '"Equal with God" Denied',
    kjvRef: 'Philippians 2:6',
    kjv: '"Who, being in the form of God, THOUGHT IT NOT ROBBERY TO BE EQUAL WITH GOD:"',
    issue: 'Changed to "did not count equality with God a thing to be grasped." This implies that Jesus could not attain equality with God, rather than affirming He already possessed it.',
    examples: [
      { ver:'ESV', text:'"...did not count equality with God A THING TO BE GRASPED"' },
      { ver:'NIV', text:'"...did not consider equality with God SOMETHING TO BE USED TO HIS OWN ADVANTAGE"' },
    ],
  },
  {
    title: 'The Heavenly Witness Removed',
    kjvRef: '1 John 5:7-8',
    kjv: '"For there are three that bear record in heaven, THE FATHER, THE WORD, AND THE HOLY GHOST: AND THESE THREE ARE ONE. And there are three that bear witness in earth, the Spirit, and the water, and the blood: and these three agree in one."',
    issue: 'The Trinitarian clause is completely removed. The clearest statement of the Trinity in the Bible is stripped from modern versions.',
    examples: [
      { ver:'NIV', text:'"For there are three that testify: the Spirit, the water and the blood; and the three are in agreement." [ENTIRE TRINITARIAN CLAUSE REMOVED]' },
      { ver:'ESV', text:'"For there are three that testify: the Spirit and the water and the blood; and these three agree." [ENTIRE TRINITARIAN CLAUSE REMOVED]' },
    ],
  },
];

const DOCTRINE = [
  {
    title: 'Salvation by Faith Removed (Acts 8:37)',
    kjvRef: 'Acts 8:36-38',
    kjv: '"...See, here is water; what doth hinder me to be baptized? AND PHILIP SAID, IF THOU BELIEVEST WITH ALL THINE HEART, THOU MAYEST. AND HE ANSWERED AND SAID, I BELIEVE THAT JESUS CHRIST IS THE SON OF GOD. And he commanded the chariot to stand still..."',
    issue: 'Entire verse removed. The text skips from verse 36 to verse 38, removing the confession of faith prerequisite for baptism. Without this verse, baptism has no stated requirement of belief, opening the door to infant baptism and baptismal regeneration.',
    examples: [
      { ver:'NIV', text:'[VERSE 37 ENTIRELY REMOVED]' },
      { ver:'ESV', text:'[VERSE 37 ENTIRELY REMOVED]' },
    ],
  },
  {
    title: 'Fasting Removed from Spiritual Warfare',
    kjvRef: 'Matthew 17:21',
    kjv: '"Howbeit this kind goeth not out but by PRAYER AND FASTING."',
    issue: 'Entire verse removed. The Lord Jesus Christ\'s own teaching on the necessity of prayer and fasting in spiritual warfare is gone.',
    examples: [
      { ver:'NIV', text:'[VERSE 17:21 ENTIRELY REMOVED]' },
      { ver:'ESV', text:'[VERSE 17:21 ENTIRELY REMOVED]' },
    ],
  },
  {
    title: '"Hell" Changed to "Hades"',
    kjvRef: 'Luke 16:23',
    kjv: '"And in HELL he lift up his eyes, being in torments..."',
    issue: '"Hell" is replaced with "Hades" throughout the New Testament. Hades is a Greek mythological term that softens the reality of eternal punishment. The KJV uses "hell" in Matthew 11:23, 16:18; Luke 10:15, 16:23; Acts 2:27; Revelation 1:18, 20:13-14. Most modern versions replace it with "Hades."',
    examples: [
      { ver:'NIV', text:'"In HADES, where he was in torment..."' },
      { ver:'ESV', text:'"...and in HADES, being in torment, he lifted up his eyes..."' },
    ],
  },
  {
    title: '"Damnation" Changed to "Condemnation"',
    kjvRef: 'Matthew 23:33',
    kjv: '"Ye serpents, ye generation of vipers, how can ye escape the DAMNATION of hell?"',
    issue: 'Weakened to "condemnation" or "judgment," which softens the severity and finality of God\'s judgment. "Damnation" carries the weight of eternal finality. "Condemnation" and "judgment" make hell sound like a courtroom ruling rather than an everlasting sentence.',
    examples: [
      { ver:'NIV', text:'"...How will you escape being CONDEMNED to hell?"' },
      { ver:'ESV', text:'"...how are you to escape being SENTENCED to hell?"' },
    ],
  },
];

const BOOKS = [
  { name:'Matthew', count:25, changes:[
    '5:22 OMIT "without a cause"','5:44 OMIT 12 words ("bless them that curse you...")','6:13 OMIT last 14 words ("For thine is the kingdom...")','6:33 OMIT "of God"','8:29 OMIT "Jesus"','11:23 CHG "hell" TO "Hades"','12:40 CHG "whale" TO "fish"','12:47 OMIT entire verse','15:8 OMIT "draweth nigh unto me with their mouth"','16:18 CHG "hell" TO "Hades"','16:20 OMIT "Jesus"','17:21 OMIT verse','18:11 OMIT verse ("For the Son of man is come...")','18:26 OMIT "and worshipped him"','19:9 OMIT last 11 words','19:17 CHG "Why callest thou me good"','20:16 OMIT "for many be called, but few chosen"','20:20 CHG "worshipping him" TO "kneeling down"','20:22 OMIT 12 words','21:44 OMIT entire verse','23:14 OMIT entire verse','23:33 CHG "damnation" TO "condemn"','25:13 OMIT "wherein the Son of man cometh"','27:35 OMIT last 25 words','27:54 CHG "the Son of God" TO "a son of God"',
  ]},
  { name:'Mark', count:17, changes:[
    '1:1 OMIT "the Son of God"','1:2 CHG "prophets" TO "Isaiah" (error)','1:14 OMIT "of the kingdom"','3:29 CHG "eternal damnation" TO "eternal sin"','6:11 OMIT last 23 words','7:8 OMIT last 15 words','7:16 OMIT entire verse','9:24 OMIT "Lord"','9:44, 46 OMIT entire verses (hell)','10:21 OMIT "take up the cross"','10:24 OMIT "for them that trust in riches"','11:10 OMIT "that cometh in the name of the Lord"','11:26 OMIT entire verse','12:40 CHG "damnation" TO "condemnation"','13:6 CHG "I am Christ" TO "I am He"','15:28 OMIT entire verse','16:9-20 OMIT last 12 verses',
  ]},
  { name:'Luke', count:21, changes:[
    '1:28 OMIT "blessed art thou among women"','2:33 CHG "Joseph" TO "his father" (virgin birth)','2:43 CHG "Joseph and his mother" TO "parents"','4:4 OMIT "but by every word of God"','4:8 OMIT "get thee behind me, Satan"','4:18 OMIT 8 words ("he hath sent me to heal...")','4:41 OMIT "Christ"','6:48 CHG "founded upon a rock" TO "well built"','9:55 OMIT 9 words','9:56 OMIT first 16 words ("For the Son of man...")','10:15 CHG "hell" TO "Hades"','11:2 OMIT 15 words Lord\'s Prayer','11:4 OMIT "but deliver us from evil"','16:23 CHG "hell" TO "Hades"','17:36 OMIT entire verse','21:4 OMIT "cast in unto the offerings of God"','21:8 CHG "I am Christ" TO "I am He"','22:64 OMIT "they struck him on the face"','23:17 OMIT entire verse','23:38 OMIT "letters of Greek, and Latin, and Hebrew"','23:42 OMIT "Lord" (thief on the cross)',
  ]},
  { name:'John', count:20, changes:[
    '1:14, 18 OMIT "begotten"','1:27 OMIT "is preferred before me"','3:13 OMIT "which is in heaven"','3:15 OMIT "should not perish"','3:16, 18 OMIT "begotten"','4:24 CHG "God is a Spirit" TO "God is Spirit"','4:42 OMIT "the Christ"','5:3 OMIT last 7 words','5:4 OMIT entire verse','5:16 OMIT "and sought to slay him"','5:29 CHG "damnation" TO "judgment"','6:47 OMIT "on Me"','6:69 CHG "Christ, the Son of the living God" TO "Holy One of God"','7:53-8:11 OMIT all verses','8:9 OMIT "being convicted by their own conscience"','8:59 OMIT last 10 words','9:35 CHG "Son of God" TO "Son of Man"','14:2 CHG "mansions" TO "rooms"','14:16 CHG "Comforter" TO "Helper"','16:16 OMIT "because I go to the Father"',
  ]},
  { name:'Acts', count:27, changes:[
    '1:3 CHG "infallible" TO "convincing"','2:30 OMIT "he would raise up Christ"','2:31 CHG "hell" TO "Hades"','4:27, 30 CHG "holy child" TO "holy servant"','7:30 OMIT "of the Lord"','8:37 OMIT entire verse (salvation)','9:5 OMIT "it is hard for thee to kick against the pricks"','10:6 OMIT "he shall tell thee what thou oughtest to do"','15:11 OMIT "Christ"','15:34 OMIT entire verse','16:31 OMIT "Christ" ("Believe on the Lord Jesus Christ")','17:22 CHG "superstitious" TO "religious"','17:26 OMIT "blood"','17:29 CHG "Godhead" TO "Divine Nature"','20:24 OMIT "none of these things move me"','20:25 OMIT "of God"','23:9 OMIT "let us not fight against God"','24:7 OMIT entire verse','28:29 OMIT entire verse',
  ]},
  { name:'Romans', count:19, changes:[
    '1:3 OMIT "Jesus Christ our Lord"','1:16 OMIT "of Christ"','1:29 OMIT "fornication"','8:1 OMIT last 10 words ("who walk not after the flesh...")','10:17 CHG "word of God" TO "word of Christ"','11:6 OMIT last 18 words','13:2 CHG "damnation" TO "judgment"','13:9 OMIT "Thou shalt not bear false witness"','14:10 CHG "judgement seat of Christ" TO "judgment seat of God"','16:24 OMIT entire verse',
  ]},
  { name:'1 Corinthians', count:18, changes:[
    '5:4 OMIT "Christ" (twice)','5:7 OMIT "for us" ("Christ sacrificed...")','6:20 OMIT "and in your spirit, which are God\'s"','7:5 OMIT "fasting"','9:1 OMIT "Christ"','10:28 OMIT last 10 words','11:24 OMIT "take eat... broken..." (Lord\'s Supper)','11:29 CHG "damnation" TO "judgment"','15:47 CHG "Lord from heaven" TO "man from heaven"','15:55 CHG "grave" TO "Hades"','16:22 OMIT "Jesus Christ"',
  ]},
  { name:'Colossians', count:4, changes:[
    '1:2 OMIT "and the Lord Jesus Christ"','1:14 OMIT "through his blood" (redemption)','1:28 OMIT "Jesus"','3:6 OMIT "on the children of disobedience"',
  ]},
  { name:'1 John', count:9, changes:[
    '1:7 OMIT "Christ"','3:16 OMIT "of God"','4:3 OMIT "Christ is come in the flesh"','4:9 OMIT "begotten"','4:19 OMIT "him" ("We love him, because...")','5:7 OMIT "the Father, the Word, and the Holy Ghost: and these three are one"','5:8 OMIT first 9 words','5:13 OMIT last 13 words',
  ]},
  { name:'Revelation', count:20, changes:[
    '1:8 OMIT "the beginning and the ending"','1:9 OMIT "Christ" (twice)','1:11 OMIT "I am Alpha and Omega"','1:18 CHG "hell" TO "Hades"','2:15 OMIT "which thing I hate"','5:14 OMIT "him that liveth for ever and ever"','11:17 OMIT "and art to come" (second coming)','14:5 OMIT "before the throne of God"','15:3 CHG "King of saints" TO "King of the ages"','20:12 CHG "stand before God" TO "before the throne"','20:13-14 CHG "hell" TO "Hades"','21:24 OMIT "of them which are saved"','22:14 CHG "do his commandments" TO "wash their robes"',
  ]},
];

/* ──────── COMPONENTS ──────── */
function ComparisonCard({ d }) {
  return (
    <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(197,165,90,0.12)', padding:'2rem', marginBottom:'2rem' }}>
      <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.35rem', color:'var(--crimson)', marginBottom:'1rem', paddingBottom:'.75rem', borderBottom:'1px solid rgba(197,165,90,0.1)' }}>{d.title}</h3>
      {/* KJV */}
      <div style={{ borderLeft:'3px solid var(--gold)', padding:'.75rem 1.5rem', background:'rgba(197,165,90,0.04)', marginBottom:'1rem' }}>
        <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, color:'var(--gold)', marginBottom:'.25rem' }}>KJV {d.kjvRef}</p>
        <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1rem', lineHeight:1.8, color:'rgba(245,240,232,0.92)' }}>{d.kjv}</p>
      </div>
      {/* Issue */}
      <p style={{ fontSize:'.95rem', lineHeight:1.9, color:'rgba(245,240,232,0.8)', marginBottom:'1rem' }}>{d.issue}</p>
      {/* Modern examples */}
      {d.examples.map((ex,i) => (
        <div key={i} style={{ borderLeft:'3px solid var(--crimson)', padding:'.5rem 1.25rem', background:'rgba(178,34,52,0.04)', marginBottom:'.5rem' }}>
          <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, color:'var(--crimson)', marginBottom:'.15rem' }}>{ex.ver}</p>
          <p style={{ fontStyle:'italic', fontSize:'.9rem', lineHeight:1.7, color:'rgba(245,240,232,0.7)' }}>{ex.text}</p>
        </div>
      ))}
    </div>
  );
}

function BookAccordion({ book }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ border:'1px solid rgba(197,165,90,0.1)', marginBottom:'.5rem' }}>
      <button onClick={() => setOpen(!open)} style={{
        width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center',
        padding:'1rem 1.5rem', background: open ? 'rgba(197,165,90,0.06)' : 'rgba(255,255,255,0.02)',
        border:'none', cursor:'pointer', color:'var(--white)', fontFamily:"'Oswald',sans-serif",
        fontSize:'.85rem', letterSpacing:2, textTransform:'uppercase', textAlign:'left', transition:'.3s',
      }}>
        <span>{book.name} <span style={{ color:'var(--gold)', fontSize:'.75rem' }}>({book.count} changes)</span></span>
        <span style={{ color:'var(--gold)', transition:'.3s', transform: open ? 'rotate(180deg)' : '' }}>&#9662;</span>
      </button>
      {open && (
        <div style={{ padding:'1rem 1.5rem', background:'rgba(0,0,0,0.1)' }}>
          {book.changes.map((c,i) => (
            <div key={i} style={{ padding:'.4rem 0', borderBottom:'1px solid rgba(255,255,255,0.03)', fontSize:'.85rem', lineHeight:1.7, color:'rgba(245,240,232,0.75)' }}>
              <span style={{ fontFamily:"'Oswald',sans-serif", color:'var(--gold)', fontSize:'.8rem', marginRight:'.5rem' }}>{c.split(' ')[0]}</span>
              {c.substring(c.indexOf(' ')+1)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ──────── APOCRYPHA DATA ──────── */
const APOCRYPHA = [
  {
    id:'enoch', name:'Book of Enoch', stamp:'Rejected: Contradicts Scripture',
    points:[
      { claim:'Enoch attributes creation-level authority to angels, names them as cosmic rulers, and describes heavenly geography in detail nowhere found in the rest of the Bible.', rebuke:'"For by him were all things created, that are in heaven, and that are in earth" (Colossians 1:16). Enoch\'s elaborate angel hierarchies rival gnostic mythology, not biblical theology.' },
      { claim:'Jude 14 quotes Enoch the man, not the book.', rebuke:'Jude, writing under inspiration, records a prophecy of Enoch the person, just as Paul quoted pagan poets (Acts 17:28, Titus 1:12). Quoting a person does not canonize a book written centuries later and attributed to them.' },
    ],
    note:'The Book of Enoch\'s teachings on angel mythology, cosmic geography, and elaborate end-times timelines contradict the simplicity and clarity of the 66-book Bible.',
  },
  {
    id:'tobit', name:'Tobit (Tobias)', stamp:'Rejected: Teaches Witchcraft',
    points:[
      { claim:'Tobit teaches magical incantation: "Open the fish, and take the heart and the liver and the gall... if a devil or an evil spirit trouble any, we must make a smoke thereof before the man or the woman, and the party shall no more be vexed" (Tobit 6:4-8). This is sorcery, using physical objects and smoke rituals to cast out devils.', rebuke:'"And these signs shall follow them that believe; In my name shall they cast out devils" (Mark 16:17). Demons are cast out in the name of Jesus Christ, not by burning fish organs.' },
      { claim:'Tobit teaches salvation by works: "For alms doth deliver from death, and shall purge away all sin" (Tobias 12:9). This directly contradicts the Bible\'s teaching that salvation is by grace through faith.', rebuke:'"Forasmuch as ye know that ye were not redeemed with corruptible things, as silver and gold... with the precious blood of Christ" (1 Peter 1:18-19)' },
    ],
    note:'The book of Tobit reads as a fable, not as a book of the Bible. Its reliance on magical rituals and works-based salvation places it squarely at odds with every doctrine taught in the 66 books of the King James Bible.',
  },
  {
    id:'maccabees', name:'2 Maccabees', stamp:'Rejected: Contradicts the Bible',
    points:[
      { claim:'2 Maccabees teaches prayer for the dead: "It is therefore a holy and wholesome thought to pray for the dead, that they may be loosed from sins" (2 Maccabees 12:46). This is the foundation for the Roman Catholic doctrine of purgatory, and it directly contradicts the Bible.', rebuke:'"And as it is appointed unto men once to die, but after this the judgment" (Hebrews 9:27). There is no second chance, no prayers to change the state of the dead, no purgatory.' },
    ],
    note:'The Council of Trent (1546) decreed: "Whoever shall not receive as sacred and canonical all these books... let him be accursed." Rome had to force these books into the Canon by decree because Christians had already rejected them for over a thousand years.',
  },
  {
    id:'judith', name:'Book of Judith', stamp:'Rejected: Promotes Deception and Historical Errors',
    points:[
      { claim:'Judith uses deliberate deception and seduction to accomplish God\'s purposes. She lies repeatedly to Holofernes (Judith 11:5-19), flattering him with false promises, and uses her physical beauty as a weapon to lure him to his death. The book presents this as righteous and praiseworthy.', rebuke:'"Lying lips are abomination to the LORD: but they that deal truly are his delight" (Proverbs 12:22). God never requires His people to sin in order to accomplish His will.' },
      { claim:'Judith contains glaring historical errors. It calls Nebuchadnezzar "king of the Assyrians" who "reigned in Nineveh" (Judith 1:1). Nebuchadnezzar was king of Babylon, not Assyria. Nineveh had already fallen before his reign. The 66 books of the KJV contain no such historical blunders.', rebuke:'' },
    ],
    note:'Its historical errors alone disqualify it from standing alongside the inerrant 66 books of the King James Bible.',
  },
  {
    id:'manasseh', name:'Prayer of Manasseh', stamp:'Rejected: Contradicts Scripture',
    points:[
      { claim:'The Prayer of Manasseh claims that repentance was not appointed to the righteous patriarchs because they "have not sinned against thee." The full sentence reads: "Thou therefore, O Lord, that art the God of the just, hast not appointed repentance to the just, as to Abraham, and Isaac, and Jacob, which have not sinned against thee; but thou hast appointed repentance unto me that am a sinner." This claims Abraham, Isaac, and Jacob did not sin against God whatsoever.', rebuke:'"For all have sinned, and come short of the glory of God" (Romans 3:23). The Bible makes no exception for any man other than the Lord Jesus Christ.' },
    ],
    note:'The Prayer of Manasseh\'s teaching on the sinlessness of the patriarchs contradicts the rest of the Bible.',
  },
  {
    id:'wisdom', name:'Wisdom of Solomon', stamp:'Rejected: False Authorship and Pagan Philosophy',
    points:[
      { claim:'The book falsely claims Solomon as its author. Internal evidence and scholarly consensus agree it was written in Greek, centuries after Solomon\'s death, likely in Alexandria, Egypt. Solomon wrote in Hebrew. This book is a forgery bearing his name.', rebuke:'"Add thou not unto his words, lest he reprove thee, and thou be found a liar" (Proverbs 30:6)' },
      { claim:'It teaches the pre-existence of the soul: "Being good, I came into a body undefiled" (Wisdom 8:20). This is Greek philosophy, not biblical doctrine.', rebuke:'"Then shall the dust return to the earth as it was: and the spirit shall return unto God who gave it" (Ecclesiastes 12:7). The soul does not pre-exist the body.' },
    ],
    note:'The Wisdom of Solomon is saturated with Greek philosophical concepts from Plato and Alexandria, not from the God of Abraham, Isaac, and Jacob. It has no place alongside the pure words of the King James Bible.',
  },
  {
    id:'ecclesiasticus', name:'Ecclesiasticus (Sirach)', stamp:'Rejected: Offensive to God\'s Character',
    points:[
      { claim:'"Any iniquity is insignificant compared to a wife\'s iniquity" (Ecclesiasticus 25:19). This is not the character of God.', rebuke:'"For all have sinned, and come short of the glory of God" (Romans 3:23). The Bible does not teach that women bear greater guilt.' },
      { claim:'"It is a disgrace to be the father of an undisciplined son, and the birth of a daughter is a loss" (Ecclesiasticus 22:3).', rebuke:'"Lo, children are an heritage of the LORD: and the fruit of the womb is his reward" (Psalm 127:3). The birth of a daughter is a gift from God, not a "loss."' },
    ],
    note:'Ecclesiasticus contains statements that are offensive and contrary to the character of God as revealed in the 66 books of the King James Bible.',
  },
];

function ApocryphaSection() {
  const [selected, setSelected] = useState(null);
  const current = APOCRYPHA.find(a => a.id === selected);

  return (
    <div>
      {/* Book selector buttons */}
      <div style={{ display:'flex', flexWrap:'wrap', gap:'.5rem', justifyContent:'center', marginBottom:'2rem' }}>
        {APOCRYPHA.map(a => (
          <button key={a.id} onClick={() => setSelected(selected === a.id ? null : a.id)} style={{
            padding:'.6rem 1.25rem', background: selected === a.id ? 'rgba(178,34,52,0.15)' : 'rgba(255,255,255,0.04)',
            border: `1px solid ${selected === a.id ? 'rgba(178,34,52,0.4)' : 'rgba(197,165,90,0.15)'}`,
            color: selected === a.id ? '#cc3344' : 'rgba(245,240,232,0.7)',
            fontFamily:"'Oswald',sans-serif", fontSize:'.75rem', letterSpacing:1.5, textTransform:'uppercase',
            cursor:'pointer', transition:'.3s',
          }}>{a.name}</button>
        ))}
      </div>

      {/* Result panel */}
      {current && (
        <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(197,165,90,0.12)', padding:'2rem', animation:'fadeIn .4s ease' }}>
          {/* Bars */}
          <div style={{ marginBottom:'1.5rem' }}>
            <div style={{ padding:'.6rem 1.25rem', background:'rgba(197,165,90,0.08)', border:'1px solid rgba(197,165,90,0.2)', marginBottom:'.5rem', fontSize:'.75rem', fontFamily:"'Oswald',sans-serif", letterSpacing:2, color:'var(--gold)', textTransform:'uppercase' }}>
              The Holy Bible: 66 Books, Perfect and Without Contradiction
            </div>
            <div style={{ padding:'.6rem 1.25rem', background:'rgba(178,34,52,0.08)', border:'1px solid rgba(178,34,52,0.2)', marginBottom:'.5rem', fontSize:'.75rem', fontFamily:"'Oswald',sans-serif", letterSpacing:2, color:'var(--crimson)', textTransform:'uppercase' }}>
              {current.name}
            </div>
            <div style={{ padding:'.5rem 1.25rem', background:'rgba(178,34,52,0.12)', border:'1px solid rgba(178,34,52,0.3)', fontSize:'.8rem', fontFamily:"'Playfair Display',serif", fontWeight:700, color:'#cc3344', fontStyle:'italic' }}>
              ✗ {current.stamp}
            </div>
          </div>

          {/* Contradiction points */}
          <h4 style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.75rem', letterSpacing:2, textTransform:'uppercase', color:'var(--gold)', marginBottom:'1rem' }}>
            Why the Bible Rejects {current.name}
          </h4>
          {current.points.map((p,i) => (
            <div key={i} style={{ marginBottom:'1.25rem', padding:'1.25rem', background:'rgba(0,0,0,0.15)', borderLeft:'3px solid var(--crimson)' }}>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.85)', marginBottom: p.rebuke ? '.75rem' : 0 }}>
                {p.claim}
              </p>
              {p.rebuke && (
                <div style={{ borderLeft:'3px solid var(--gold)', padding:'.5rem 1rem', background:'rgba(197,165,90,0.04)', marginTop:'.5rem' }}>
                  <p style={{ fontSize:'.85rem', lineHeight:1.7, color:'rgba(245,240,232,0.75)', fontStyle:'italic' }}>
                    <span style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.65rem', letterSpacing:2, color:'var(--gold)', fontStyle:'normal', display:'block', marginBottom:'.25rem' }}>THE BIBLE SAYS:</span>
                    {p.rebuke}
                  </p>
                </div>
              )}
            </div>
          ))}

          {/* Note */}
          <p style={{ fontSize:'.85rem', lineHeight:1.8, color:'rgba(245,240,232,0.6)', fontStyle:'italic', marginTop:'1rem', padding:'1rem', background:'rgba(197,165,90,0.03)', borderTop:'1px solid rgba(197,165,90,0.1)' }}>
            {current.note}
          </p>
        </div>
      )}
    </div>
  );
}

/* ──────── PAGE ──────── */
export default function WhyKJV() {
  const [section, setSection] = useState('');

  const scrollTo = (id) => {
    setSection(id);
    document.getElementById(id)?.scrollIntoView({ behavior:'smooth', block:'start' });
  };

  return (
    <>
      {/* HERO */}
      <section className="hero" style={{ background:'linear-gradient(165deg,var(--navy) 0%,var(--deep-blue) 40%,var(--royal) 100%)', minHeight:'auto', padding:'5rem 2rem 4rem' }}>
        <div className="inner" style={{ textAlign:'center' }}>
          <div className="section-label center">A Careful Examination</div>
          <h1 className="section-title" style={{ fontSize:'clamp(2rem,5vw,3.5rem)', marginBottom:'1rem' }}>
            Why the King James Bible?
          </h1>
          <p style={{ fontSize:'1.05rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)', maxWidth:650, margin:'0 auto 2rem' }}>
            What modern translations have changed, removed, and redefined.
          </p>
          <div style={{ maxWidth:600, margin:'0 auto', padding:'1.25rem 2rem', borderLeft:'3px solid var(--gold)', background:'rgba(197,165,90,0.06)', textAlign:'left' }}>
            <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.1rem', lineHeight:1.7, color:'rgba(245,240,232,0.92)', marginBottom:'.25rem' }}>
              "...ye have perverted the words of the living God, of the LORD of hosts our God."
            </p>
            <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.8rem', letterSpacing:2, color:'var(--gold)' }}>Jeremiah 23:36</p>
          </div>
        </div>
      </section>

      {/* STICKY TOC */}
      <div style={{ position:'sticky', top:60, zIndex:100, background:'rgba(10,22,40,0.95)', backdropFilter:'blur(12px)', borderBottom:'1px solid rgba(197,165,90,0.15)', padding:'.5rem 0', overflowX:'auto' }}>
        <div style={{ display:'flex', justifyContent:'center', gap:0, maxWidth:900, margin:'0 auto' }}>
          {[['overview','Overview'],['removed','Removed Verses'],['deity','Deity of Christ'],['doctrine','Doctrine'],['by-book','By Book'],['apocrypha','Apocrypha'],['conclusion','Why the KJV']].map(([id,label]) => (
            <button key={id} onClick={() => scrollTo(id)} style={{
              background:'none', border:'none', cursor:'pointer', padding:'.75rem 1rem', whiteSpace:'nowrap',
              fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, textTransform:'uppercase',
              color: section === id ? 'var(--gold)' : 'rgba(245,240,232,0.5)', borderBottom: section === id ? '2px solid var(--gold)' : '2px solid transparent',
              transition:'.3s',
            }}>{label}</button>
          ))}
        </div>
      </div>

      <div className="divider" />

      {/* OVERVIEW */}
      <section id="overview" style={{ background:'linear-gradient(180deg,var(--navy),var(--deep-blue))' }}>
        <div className="inner">
          <h2 className="section-title">The Scope of the Changes</h2>
          <div className="about-content" style={{ maxWidth:750 }}>
            <p>Jesus Christ warned in the parable of the sower that "the SEED is the word of God... then cometh THE DEVIL, and TAKETH AWAY the word out of their hearts, lest they should believe and be saved." (Luke 8:11-12). The adversary's strategy has not changed. Modern Bible versions have systematically removed words, verses, and clarity from the Bible.</p>
            <p>The following comparison examines changes found in the NIV, NASV, NKJV, RSV, NRSV, NCV, ESV, and LIV as compared to the KJV. The changes are not trivial, for they strike at the deity of Christ, the doctrine of salvation, and the authority of the Bible.</p>
          </div>
          {/* Stats */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))', gap:'1.5rem', marginTop:'2.5rem', maxWidth:700, margin:'2.5rem auto 0' }}>
            {[['17+','Complete Verses Removed'],['100s','Words Omitted'],['64,000+','Fewer Words (NIV)'],['7','Major Versions Compared']].map(([num,label],i) => (
              <div key={i} style={{ textAlign:'center', padding:'1.5rem 1rem', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(197,165,90,0.1)' }}>
                <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'2.5rem', fontWeight:700, color:'var(--crimson)' }}>{num}</div>
                <div style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, textTransform:'uppercase', color:'var(--gold)', marginTop:'.25rem' }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* REMOVED VERSES */}
      <section id="removed" style={{ background:'var(--deep-blue)' }}>
        <div className="inner">
          <h2 className="section-title">Verses Footnoted or Removed</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2rem' }}>These entire verses are removed from or placed in footnotes by modern versions.</p>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:'.75rem' }}>
            {REMOVED.map((r,i) => (
              <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'.75rem 1.25rem', background:'rgba(255,255,255,0.02)', border:'1px solid rgba(178,34,52,0.1)' }}>
                <span style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.85rem', color:'var(--white)', fontWeight:600 }}>{r.ref}</span>
                <span style={{ fontSize:'.65rem', textAlign:'right', maxWidth:'55%' }}>
                  {r.v.split(' · ').map((part,j) => {
                    const isT = part.endsWith(': T') || part.endsWith(':T');
                    const isF = part.endsWith(': F') || part.endsWith(':F');
                    return (
                      <span key={j}>
                        {j > 0 && <span style={{ color:'rgba(245,240,232,0.25)' }}> · </span>}
                        <span style={{ color:'rgba(245,240,232,0.5)' }}>{part.replace(/: [TF]$/, ': ')}</span>
                        {isT && <span style={{ color:'#B22234', fontWeight:700 }}>T</span>}
                        {isF && <span style={{ color:'#C5A55A', fontWeight:700 }}>F</span>}
                        {!isT && !isF && <span style={{ color:'rgba(245,240,232,0.5)' }}>{part.split(': ')[1] || ''}</span>}
                      </span>
                    );
                  })}
                </span>
              </div>
            ))}
          </div>
          <p style={{ textAlign:'center', fontSize:'.8rem', color:'rgba(245,240,232,0.45)', marginTop:'.75rem' }}>
            <strong style={{ color:'var(--crimson)' }}>T</strong> = Taken Away &nbsp;&nbsp; <strong style={{ color:'var(--gold)' }}>F</strong> = Taken Away in Footnotes
          </p>

          {/* Callout */}
          <div style={{ marginTop:'2rem', padding:'2rem', background:'rgba(197,165,90,0.04)', border:'1px solid rgba(197,165,90,0.12)' }}>
            <h4 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--gold)', marginBottom:'.75rem' }}>Why Does This Matter?</h4>
            <p style={{ fontSize:'.95rem', lineHeight:1.9, color:'rgba(245,240,232,0.8)', marginBottom:'.75rem' }}>
              Shouldn't it matter what God said? People today settle for just the "gist" or "general idea" of what God said. Shouldn't the actual <em>words</em> He spoke matter to us? When Jesus was being tempted in the wilderness by Satan, He rebuked the devil each time with the <em>words</em> of God.
            </p>
            <p style={{ fontSize:'.95rem', lineHeight:1.9, color:'rgba(245,240,232,0.8)' }}>
              Jesus was hungry after fasting for 40 days, and Satan tempted Him. We then see that Jesus <strong>"answered and said, It is written, Man shall not live by bread alone, but by every word that proceedeth out of the mouth of God."</strong> Man is supposed to be living "by every word that proceedeth out of the mouth of God." Then our question must be: where do we find the <em>words</em> of God that are pure and true?
            </p>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* DEITY OF CHRIST */}
      <section id="deity" style={{ background:'linear-gradient(180deg,var(--deep-blue),var(--navy))' }}>
        <div className="inner">
          <h2 className="section-title">Attacks on the Deity of Christ</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2.5rem', maxWidth:650, margin:'0 auto 2.5rem' }}>
            One of the most alarming patterns in modern translations is the systematic weakening of passages that declare the deity of Jesus Christ.
          </p>
          {DEITY.map((d,i) => <ComparisonCard key={i} d={d} />)}
          <div style={{ borderLeft:'3px solid var(--gold)', padding:'.75rem 1.5rem', background:'rgba(197,165,90,0.04)', marginTop:'2rem' }}>
            <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.05rem', lineHeight:1.8, color:'rgba(245,240,232,0.92)', marginBottom:'.25rem' }}>
              "Who is a liar but he that denieth that Jesus is the Christ? He is antichrist, that denieth the Father and the Son."
            </p>
            <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.8rem', letterSpacing:2, color:'var(--gold)' }}>1 John 2:22</p>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* DOCTRINAL CHANGES */}
      <section id="doctrine" style={{ background:'var(--deep-blue)' }}>
        <div className="inner">
          <h2 className="section-title">Doctrinal Changes</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2.5rem' }}>Key doctrines are weakened or obscured through translation choices.</p>
          {DOCTRINE.map((d,i) => <ComparisonCard key={i} d={d} />)}
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* BY BOOK */}
      <section id="by-book" style={{ background:'linear-gradient(180deg,var(--navy),var(--deep-blue))' }}>
        <div className="inner">
          <h2 className="section-title">Changes by Book</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2rem' }}>A detailed survey of changes organized by the books of the New Testament.</p>
          {BOOKS.map((b,i) => <BookAccordion key={i} book={b} />)}
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* APOCRYPHA */}
      <section id="apocrypha" style={{ background:'var(--deep-blue)' }}>
        <div className="inner">
          <h2 className="section-title">The King James Bible<br />Rejects Corruption</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2rem', maxWidth:650, margin:'0 auto 2rem' }}>
            The King James Bible's 66 books are internally consistent, self-authenticating, and they reject every imposter.
          </p>

          <div className="about-content" style={{ maxWidth:750 }}>
            <p>Many are putting out their own versions of the Bible with changes in text just enough to cover their views or questionable doctrines. The King James Bible stands apart: its 66 books are inerrant, perfect, and contain zero contradictions. When a false book is tested against this standard, the Bible itself exposes it.</p>
            <p>Critics like to point out that the original 1611 King James Bible included the Apocrypha, as though that compromises its integrity. The translators placed it <em>between</em> the Old and New Testaments for its historical value. They never integrated it into the text as some corrupt modern versions do today. They rejected the Apocrypha as divinely inspired, and for good reason: these books contradict the rest of the Bible.</p>
          </div>

          <h3 style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.85rem', letterSpacing:3, textTransform:'uppercase', color:'var(--gold)', textAlign:'center', marginTop:'3rem', marginBottom:'1.5rem' }}>
            Test It Against the Bible
          </h3>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.5)', fontSize:'.9rem', marginBottom:'2rem' }}>
            Select a non-canonical book below to see how the 66-book KJV Bible exposes its contradictions.
          </p>

          <ApocryphaSection />

          <div style={{ borderLeft:'3px solid var(--gold)', padding:'.75rem 1.5rem', background:'rgba(197,165,90,0.04)', margin:'2.5rem auto 0', maxWidth:700 }}>
            <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.05rem', lineHeight:1.8, color:'rgba(245,240,232,0.92)', marginBottom:'.25rem' }}>
              "Ye shall know them by their fruits. Do men gather grapes of thorns, or figs of thistles?"
            </p>
            <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.8rem', letterSpacing:2, color:'var(--gold)' }}>Matthew 7:16</p>
          </div>
        </div>
      </section>

      <div className="divider" />
      <section id="conclusion" style={{ background:'linear-gradient(180deg,var(--deep-blue),var(--navy))' }}>
        <div className="inner">
          <h2 className="section-title">Why the KJV?</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2rem' }}>God promised to preserve His Word... and He has.</p>

          <div className="about-content" style={{ maxWidth:750 }}>
            <p>The King James Bible is the preserved word of God for the English-speaking people. Its 66 books are internally consistent, doctrinally perfect, and without contradiction. Every word works together in harmony across thousands of years of authorship, because behind every human pen was one divine Author.</p>
            <p>The changes documented on this page are not mere matters of translation style. They systematically weaken the deity of Christ, remove doctrinal clarity, soften the language of judgment, and eliminate entire sections of the Bible. The pattern is consistent and unmistakable. The King James Bible preserves what the modern versions have taken away.</p>
          </div>

          {/* Fruit cards */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:'1.5rem', margin:'2.5rem 0' }}>
            <div style={{ padding:'2rem', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(197,165,90,0.12)' }}>
              <h4 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.15rem', color:'var(--gold)', marginBottom:'.75rem' }}>Internal Consistency</h4>
              <p style={{ fontSize:'.9rem', lineHeight:1.9, color:'rgba(245,240,232,0.75)' }}>66 books, approximately 40 writers, written over 1,500 years, and the King James Bible contains zero contradictions. From Genesis to Revelation, every doctrine, every prophecy, and every word agrees perfectly. No other collection of writings in human history can make this claim. Why? Because the Bible was not authored by man. It was authored by God.</p>
            </div>
            <div style={{ padding:'2rem', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(197,165,90,0.12)' }}>
              <h4 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.15rem', color:'var(--gold)', marginBottom:'.75rem' }}>Doctrinal Perfection</h4>
              <p style={{ fontSize:'.9rem', lineHeight:1.9, color:'rgba(245,240,232,0.75)' }}>The KJV does not soften sin, weaken hell, diminish the deity of Christ, or obscure the blood atonement. It says what God said, the way God said it. When the modern versions change "God" to "He" and "hell" to "Hades," they are not improving clarity. They are removing doctrine.</p>
            </div>
          </div>

          {/* Closing verses */}
          {[
            ['"The words of the LORD are pure words: as silver tried in a furnace of earth, purified seven times. Thou shalt keep them, O LORD, thou shalt preserve them from this generation for ever."','Psalm 12:6-7'],
            ['"Heaven and earth shall pass away, but my words shall not pass away."','Matthew 24:35'],
            ['"For I testify unto every man that heareth the words of the prophecy of this book, If any man shall add unto these things, God shall add unto him the plagues that are written in this book: And if any man shall take away from the words of the book of this prophecy, God shall take away his part out of the book of life, and out of the holy city, and from the things which are written in this book."','Revelation 22:18-19'],
          ].map(([text,ref],i) => (
            <div key={i} style={{ borderLeft:'3px solid var(--gold)', padding:'.75rem 1.5rem', background:'rgba(197,165,90,0.04)', margin:'1.5rem auto', maxWidth:700 }}>
              <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.05rem', lineHeight:1.8, color:'rgba(245,240,232,0.92)', marginBottom:'.25rem' }}>{text}</p>
              <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.8rem', letterSpacing:2, color:'var(--gold)' }}>{ref}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
